import { useContext, useMemo, useRef, useState } from 'react'
import { AxiosContext } from '@/context/Axios'
import { ConnectionModel, MyConnection } from '@/types'
import useAppStore from '@/store/useAppStore'
import { shallow } from 'zustand/shallow'

interface getConnectionsListParams {
  connID: string
  pageNo?: number
}

export const useConnectionsListViewModel = () => {
  const [loadingNextPage, setLoadingNextPage] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState()
  // const [connections, setConnections] = useState<ConnectionModel[] | null>(null)
  const [canLoadNextPage, setCanLoadNextPage] = useState(false)
  const axios = useContext(AxiosContext)
  let paramsRef = useRef<getConnectionsListParams | null>(null)

  const [userConnections] = useAppStore((state) => [state.user.userConnections], shallow)
  const { setUserConnections } = useAppStore()

  const connections: ConnectionModel[] = useMemo(() => {
    if (loading && (paramsRef.current?.pageNo || 1) == 1) return []
    return userConnections
  }, [userConnections, loading])

  // Fetch Connections List
  const getConnectionsList = async (params: getConnectionsListParams) => {
    const { connID, pageNo = 1 } = params
    paramsRef.current = params
    if (pageNo == 1) {
      setLoading(true)
      // setConnections(null)
    } else {
      setLoadingNextPage(true)
    }

    const response = await axios.api.post('ajax/circles', {
      requestType: 'connList',
      connID: connID,
      format: 'json',
      pageNo: pageNo,
    })

    const users: ConnectionModel[] = response.data?.connections || []

    const mappedUsers: ConnectionModel[] = users.map((e) => {
      let sentBit = e.reqSent
      let receivedBit = e.reqReceived
      return {
        ...e,
        reqSent: Boolean(receivedBit),
        reqReceived: Boolean(sentBit),
        profilePicThumbURL: e.profilePicThumbURL || e?.thumbImgURL || '',
        profilePicURL: e.profilePicURL || e?.albumImgURL || '',
      }
    })

    let finalUsers = [...mappedUsers]
    // Flipping reqSent and reqReceived
    if (pageNo > 1) {
      finalUsers = [...(connections || []), ...mappedUsers]
    }

    setUserConnections(finalUsers)
    setLoading(false)
    setLoadingNextPage(false)

    setPagination(response.data.pagination)
    if (response.data.pagination?.currentPage == response.data.pagination?.totalPage) {
      setCanLoadNextPage(false)
    } else {
      setCanLoadNextPage(true)
    }
  }

  // Load Next Page Data
  const loadNextPageData = () => {
    if (paramsRef.current != null && canLoadNextPage) {
      getConnectionsList({ ...paramsRef.current, pageNo: (paramsRef.current.pageNo || 1) + 1 })
    }
  }

  return {
    loading,
    loadingNextPage,
    canLoadNextPage,
    connections,
    getConnectionsList,
    loadNextPageData,
    pagination,
  }
}
